import React from "react";
import Stock from "./Stock";

const Produit = ({ item, ...others }) => (
  <Stock defaultItem={item} {...others} />
);

export default Produit;
